import React, { Component } from 'react';
import { HashRouter as Router, Route, Link, Switch } from 'react-router-dom';
import Map from './Map'
import List from './view/list'
import Detail from './view/detail'
import ActivityList from './view/activityList'
import Bus from './view/bus'
import About from './view/about'

import './App.scss';
class App extends Component {
  render() {
    return (
      <div className="App">
        <Switch>
          <Route exact path='/' component={Map} />
          <Route exact path='/list' component={List} />
          <Route exact path='/detail' component={Detail} />
          <Route exact path='/activityList' component={ActivityList} />
          <Route exact path='/bus' component={Bus} />
          <Route exact path='/about' component={About} />

        </Switch>
      </div>
    );
  }
}

export default App;